module.exports = __webpack_public_path__ + "static/img/lb-3.29641d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blog/lb-3.jpg
// module id = dM+t
// module chunks = 0